<app-otp-general credType="ivr" niceOtpName="Voice Call" [resendEnabled]=false></app-otp-general>
